import React from "react";
import { motion } from "framer-motion";
import { User, Cloud, GitBranch, Activity } from "lucide-react";
import portfolioData from "../../data/mock";

const highlights = [
  {
    icon: Cloud,
    label: "Azure & Infrastructure as Code",
    description:
      "Enterprise cloud environments provisioned with Terraform and ARM Templates, including Key Vault, networking and databases"
  },
  {
    icon: GitBranch,
    label: "CI/CD & Kubernetes",
    description:
      "Repeatable pipelines in Azure DevOps, GitLab CI and GitHub Actions, deploying microservices across Dev, QA and UAT"
  },
  {
    icon: Activity,
    label: "Production Support",
    description:
      "Cloud-native troubleshooting of failed rollouts, pods, logs, secrets and certificates in live environments"
  }
];

const AboutMe = () => {
  const { aboutMe } = portfolioData;

  return (
    <section id="about" className="relative py-28 bg-ink-950">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-brand-400" />
            <span className="text-brand-400 text-sm font-medium tracking-wider uppercase">
              About
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            Who I Am
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <p className="text-slate-300 text-lg leading-relaxed mb-8">
              {aboutMe}
            </p>
            <div className="flex items-center gap-2 text-sm text-slate-400">
              <User size={16} className="text-brand-400" />
              <span>Nearly 4 years building and operating enterprise cloud infrastructure</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid gap-6"
          >
            {highlights.map((item, index) => (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
                className="group flex items-start gap-4 p-5 rounded-xl border border-ink-800/60 bg-ink-900/30 hover:border-brand-500/30 hover:bg-ink-900/60 transition-all duration-300"
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-brand-500/10 flex items-center justify-center text-brand-400 group-hover:bg-brand-500/20 transition-colors duration-300">
                  <item.icon size={20} />
                </div>
                <div>
                  <h3 className="text-white font-medium mb-1">{item.label}</h3>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
